export default "__VITE_ASSET__BxDfLRD$__"